// Breakpoints canônicos PharuERP — Design System Bloco D
// ======================================================
// 1024px — Tablet (rail colapsado forçado entre 1024-1280)
//  768px — Mobile (sidebar drawer overlay; tabela -> cards)
//  360px — Mobile pequeno (compressão de tipografia + paddings)
//
// Estes números MUST espelhar os usados em src/styles/canonical/responsive-additions.css.
// Quando algum componente precisar de @media, importar daqui (NÃO hardcoded).
//
// Uso:
//   import { BP_TABLET, BP_MOBILE, BP_MOBILE_SMALL } from "@/styles/canonical/breakpoints";
//
//   // Em styled-components:
//   @media (max-width: ${BP_MOBILE}px) { ... }
//
//   // Em hooks:
//   const isMobile = useMediaQuery(`(max-width: ${BP_MOBILE}px)`);

export const BP_TABLET = 1024;
export const BP_MOBILE = 768;
export const BP_MOBILE_SMALL = 360;

// Threshold extra usado pra forçar rail colapsado entre 1024-1280px.
// Acima de 1280px sidebar fica EXPANDIDA por default.
export const BP_DESKTOP_LARGE = 1280;

// Helpers de media query string — uso comum em styled-components.
export const mq = {
  tablet: `(max-width: ${BP_TABLET}px)`,
  mobile: `(max-width: ${BP_MOBILE}px)`,
  mobileSmall: `(max-width: ${BP_MOBILE_SMALL}px)`,
  desktopLarge: `(min-width: ${BP_DESKTOP_LARGE}px)`,

  // Hover-capable devices only (dispositivos com mouse real)
  hover: "(hover: hover) and (pointer: fine)",

  // Touch-only / coarse pointers
  touch: "(hover: none) and (pointer: coarse)",
};
